import PropTypes from 'prop-types';
export const contentNotePropTypes = {
  heading: PropTypes.string,
  description: PropTypes.string
};